<template>
  <div>
    <md-progress-bar md-mode="query" class="md-accent" v-if="loadingTickets"></md-progress-bar>
    <div class="md-layout-item md-size-100" v-else>
      <md-toolbar class="md-toolbar-section-end md-transparent" md-elevation="0">
        <md-field class="md-layout-item md-size-25">
          <label>{{$t('ticket.list.filter')}}</label>
          <md-select v-model="gameSelect" name="team" id="team">
            <md-option v-for="game in nextGames" :value="game.id" :key="game.id">
              {{game.local.name}} vs {{game.visitor.name}} | {{getDate(game.scheduledMatchDate)}} - {{game.season.name}} Fecha : {{game.matchday}}
            </md-option>
          </md-select>
        </md-field>
      </md-toolbar>
      <md-table md-card v-if="tickets.length > 0">
        <md-table-row>
          <md-table-head>{{$t('ticket.list.game')}}</md-table-head>
          <md-table-head>{{$t('ticket.list.description')}}</md-table-head>
          <md-table-head>{{$t('ticket.list.team')}}</md-table-head>
          <md-table-head>{{$t('ticket.list.size')}}</md-table-head>
          <md-table-head>{{$t('ticket.list.used')}}</md-table-head>
          <!-- <md-table-head>{{$t('ticket.list.createUser')}}</md-table-head> -->
          <md-table-head>{{$t('ticket.list.actions')}}</md-table-head>
        </md-table-row>

        <md-table-row v-for="ticket in tickets" :key="ticket.id">
          <md-table-cell>{{ticket.game}}</md-table-cell>
          <md-table-cell>{{ticket.description}}</md-table-cell>
          <md-table-cell>{{ticket.team}}</md-table-cell>
          <md-table-cell>{{ticket.size}}</md-table-cell>
          <md-table-cell>{{ticket.used}}</md-table-cell>
          <!-- <md-table-cell>
            {{ticket.createUser}}
            <md-tooltip md-direction="bottom">
              <strong>{{$t("ticket.list.createDate")}}</strong><br>
              {{formatDate(ticket.createDate)}}
            </md-tooltip>
          </md-table-cell> -->
          <md-table-cell>
            <md-button class="md-info" :to="`/ticketera/detail/ticket/${ticket.id}`">
              {{$t('ticket.list.detail')}}
            </md-button>
          </md-table-cell>
        </md-table-row>
      </md-table>
      <md-empty-state
        v-if="tickets.length == 0 && nextGames.length > 0"
        md-icon="local_activity"
        md-label="Sin tickets generados"
        md-description="El partido seleccionado no tiene tickets">
      </md-empty-state>

      <md-empty-state
        v-if="tickets.length == 0 && nextGames.length == 0"
        md-icon="local_activity"
        md-label="No hay partidos proximos"
        md-description="No hay partidos proximos para mostrar tickets">
      </md-empty-state>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';

export default {
  data() {
    return {
      loadingTickets: true,
      gameSelect: 0
    }
  },
  computed: {
    ...mapState({
      tickets: state => state.TicketModule.tickets,
      nextGames: state => state.GameModule.nextGames
    })
  },
  async mounted() {
    await this.$store.dispatch("gameGetNext")
    if (this.nextGames.length > 0) {
      this.gameSelect = this.nextGames[0].id
      await this.$store.dispatch('ticketLotGet', {gameId : this.gameSelect})
    }
    this.loadingTickets = false
  },
  methods: {
    getDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm")
    }
  },
  watch: {
    async gameSelect() {
      this.loadingTickets = true
      await this.$store.dispatch('ticketLotGet', {gameId : this.gameSelect})
      this.loadingTickets = false
    }
  }
}
</script>

<style>

</style>